import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FormTitle from '@src/mobile/layout/Component/FormTitle';
import FormInput from '@src/mobile/layout/Component/FormInput';
import FormTextarea from '@src/mobile/layout/Component/FormTextarea';
import UploadVideo from '../Media/UploadVideo';

const Needlessly = ({
    formData,
    setFormDataHandle,
    warningTextList,
    updateSuccess
}) => {
    const [isUnfold, setUnfold] = useState(false);

    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    const unflodHandle = () => {
        setUnfold(!isUnfold);
    };

    return (
        <div className={styles.needlessly}>
            <div className={styles.needlesslyHead}>
                <div className={styles.needlesslyTitle}>选填信息</div>
                <div className={`${styles.needlesslyChange}`} onClick={unflodHandle}>
                    <img className={styles.needlesslyPic1} style={{ display: isUnfold ? 'block' : 'none' }} src="https://x0.ifengimg.com/feprod/c/2025_7_21/13_12_29/expand.png" />
                    <img className={styles.needlesslyPic2} style={{ display: !isUnfold ? 'block' : 'none' }} src="https://x0.ifengimg.com/feprod/c/2025_7_21/13_12_29/collapse.png" />
                </div>
            </div>
            <div className={styles.needlesslyInfo}>
                更丰富的自我介绍，能让我们更快速地了解你。
            </div>
            <div style={{ display: isUnfold ? 'block' : 'none' }} className={styles.formNeedlesslyList}>
                <div className={styles.formListBox}>
                    <FormTitle name="video_production" title="视频作品" warningText={warningTextList['video_production']} />
                    <div className={styles.picInfo}>选填资料可于必填资料提交之后再填写<br />
                        每个人都有治愈自己的小魔药，你有什么很热爱的事物吗?有可能是读书、运 动、旅行、手作?甚至可能是单曲循环的歌、追的剧，请分享给我们看看吧。 <br />视频要求：请上传本人出镜、不使用美颜、不使用滤镜、不配乐、带环境、 有主题、动态为主的2分钟以内的视频，9：16竖屏，以动态视频为主。画面 清晰即可，视频仅支持mp4、mov、quicktime格式。</div>
                    <UploadVideo name="video_production" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle title="擅长语种" name="language" warningText={warningTextList['language']} />
                    <FormInput name="language" formData={formData} changeInputHandle={changeInputHandle} />
                    <FormTitle
                        title="详细秀一下自己"
                        name="self_introduction"
                        warningText={warningTextList['self_introduction']}
                    />
                    <FormTextarea
                        limitWord={1000}
                        formData={formData}
                        placeholder="性格特点、参与活动经历、获奖情况及特长等"
                        name="self_introduction"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                    <FormTitle
                        title="还有哪些平台能了解你？"
                        name="other_platforms"
                        warningText={warningTextList['other_platforms']}
                    />
                    <FormTextarea
                        limitWord={300}
                        formData={formData}
                        placeholder="有的话请附上链接，没有的话可填“无”"
                        name="other_platforms"
                        changeInputHandle={changeInputHandle}
                        updateSuccess={updateSuccess}
                    />
                </div>
            </div>
        </div>
    );
};

Needlessly.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateSuccess: PropTypes.bool,
};

export default errorBoundary(Needlessly);
